import { calculateVat } from '../vatRates/VatRatesMgr';
export const accumulatePrices = (topLevelOrderLines) => {
    const accumulatePricesRecurse = function (line) {
        let totalPriceAccumFromSublinesSummed = 0;
        let totalPriceBeforeAccumFromSublinesSummed = 0;
        let didAnyChildNodeHaveTotalPriceAccum = false;
        let didAnyChildNodeHaveTotalPriceBeforeAccum = false;
        if (line.subLines && line.subLines.length > 0 && line.type !== 'CombinatorLine') {
            line.subLines.forEach((subLine) => {
                const { totalPriceAccum, totalPriceBeforeAccum } = accumulatePricesRecurse(subLine);
                if (Number.isFinite(totalPriceAccum)) {
                    totalPriceAccumFromSublinesSummed += totalPriceAccum;
                    didAnyChildNodeHaveTotalPriceAccum = true;
                }
                totalPriceBeforeAccumFromSublinesSummed += totalPriceBeforeAccum
                    ? totalPriceBeforeAccum
                    : totalPriceAccum
                        ? totalPriceAccum
                        : 0;
                if (Number.isFinite(totalPriceBeforeAccum)) {
                    didAnyChildNodeHaveTotalPriceBeforeAccum = true;
                }
            });
        }
        const result = {};
        const myQuantity = 'quantity' in line ? line.quantity : 1;
        if (line.type !== 'CombinatorLine') {
            const totalPrice = line.type === 'Product' || line.type === 'Discount' ? line.totalPrice : undefined;
            if (didAnyChildNodeHaveTotalPriceAccum || Number.isFinite(totalPrice)) {
                result.totalPriceAccum = myQuantity * totalPriceAccumFromSublinesSummed + (totalPrice ? totalPrice : 0);
            }
            if (didAnyChildNodeHaveTotalPriceBeforeAccum || 'totalPriceBefore' in line) {
                const effectiveTotalPriceBefore = 'totalPriceBefore' in line
                    ? line.totalPriceBefore
                    : 'totalPrice' in line && line.totalPrice
                        ? line.totalPrice
                        : 0;
                result.totalPriceBeforeAccum = myQuantity * totalPriceBeforeAccumFromSublinesSummed + effectiveTotalPriceBefore;
                if (line.isMenu && line.productId === line.rootProductId && result.totalPriceAccum < 0) {
                    result.totalPriceAccum = result.totalPriceBeforeAccum;
                }
            }
        }
        else {
            if (line.type === 'CombinatorLine') {
                line.subLines.forEach((subLine) => {
                    if (!subLine.isMenu) {
                        const aggregations = subLine.subLines.filter((item) => {
                            return item.type === 'Aggregation' && item.totalPriceAccum > 0;
                        });
                        if (aggregations && aggregations.length > 0) {
                            aggregations.forEach((aggregation) => {
                                if (aggregation && aggregation.totalPriceAccum) {
                                    totalPriceAccumFromSublinesSummed += aggregation.totalPriceAccum;
                                }
                            });
                        }
                    }
                });
            }
            result.totalPriceAccum = myQuantity * totalPriceAccumFromSublinesSummed + line.totalPriceAccum;
        }
        Object.assign(line, result);
        return result;
    };
    topLevelOrderLines.forEach(accumulatePricesRecurse);
};
export const aggregateQuantityTopDown = (rootOrderLines) => {
    function recurse(lines, ancestorQuantity = undefined) {
        lines.forEach((line) => {
            const hasQuantity = 'quantity' in line && line.quantity !== undefined;
            if (hasQuantity) {
                if (ancestorQuantity !== undefined) {
                    line.aggregatedQuantity = ancestorQuantity;
                }
                else {
                    line.aggregatedQuantity = 1;
                }
            }
            function getNewAncestorQuantity() {
                if (ancestorQuantity === undefined && !hasQuantity) {
                    return undefined;
                }
                else {
                    const q1 = ancestorQuantity !== undefined ? ancestorQuantity : 1;
                    const q2 = 'quantity' in line ? line.quantity : 1;
                    return q1 * q2;
                }
            }
            if (line.subLines && line.subLines.length) {
                const newAncestorQuantity = getNewAncestorQuantity();
                recurse(line.subLines, newAncestorQuantity);
            }
        });
    }
    recurse(rootOrderLines);
};
export function fixPricesForProductsWithFreeAdditionsG5(lines) {
    function fixPricesRecurse(freeQuantity, lines) {
        var _a, _b, _c;
        if (!lines || lines.length === 0) {
            return;
        }
        if (freeQuantity && freeQuantity > 0) {
            lines.sort((a, b) => a.price - b.price);
            let sumQ = 0;
            let i = 0;
            while (sumQ < freeQuantity && i < lines.length) {
                const q = lines[i].quantity;
                const remaining = freeQuantity - sumQ;
                const freeQ = Math.min(q, remaining);
                const newTotalPrice = lines[i].totalPrice - freeQ * lines[i].price;
                if (newTotalPrice === 0) {
                    delete lines[i].totalPrice;
                    delete lines[i].totalVat;
                }
                else {
                    lines[i].totalPrice = newTotalPrice;
                    lines[i].totalVat = calculateVat(lines[i].vatRatePerMille, newTotalPrice);
                    if (((_c = (_b = (_a = lines[i].options.foreignIds) === null || _a === void 0 ? void 0 : _a.onlinePosRules) === null || _b === void 0 ? void 0 : _b.cart) === null || _c === void 0 ? void 0 : _c.some((c) => c.forcedConfig)) && newTotalPrice > 0) {
                        const newLineQuantity = q - freeQ;
                        const newLine = Object.assign(Object.assign({}, lines[i]), { quantity: newLineQuantity, totalPrice: lines[i].price * newLineQuantity, totalVat: calculateVat(lines[i].vatRatePerMille, lines[i].price * newLineQuantity) });
                        lines.splice(i + 1, 0, newLine);
                        lines[i].quantity = freeQuantity - sumQ;
                        if (lines[i].quantity === 0) {
                            delete lines[i].totalPrice;
                            delete lines[i].totalVat;
                        }
                        else {
                            lines[i].totalPrice = lines[i].price * lines[i].quantity;
                            lines[i].totalVat = calculateVat(lines[i].vatRatePerMille, lines[i].totalPrice);
                        }
                        delete lines[i].totalPrice;
                        delete lines[i].totalVat;
                    }
                }
                if (!lines[i].tags2) {
                    lines[i].tags2 = {};
                }
                lines[i].tags2.freeQuantity = true;
                i++;
                sumQ += freeQ;
            }
        }
        lines.forEach((line) => {
            if (line.subLines) {
                const freeQuantityOfParent = !line.options ? 0 : line.options.freeQuantity || 0;
                fixPricesRecurse(freeQuantityOfParent, line.subLines);
            }
        });
    }
    fixPricesRecurse(0, lines);
}
export const convertProductSelectionsToMap = (selections) => {
    return (selections || []).reduce((acc, item) => {
        const { productId, productSelectionId, quantity } = item;
        if (!acc[productId]) {
            acc[productId] = { quantity: 0, selections: {} };
        }
        if (!acc[productId].selections[productSelectionId]) {
            acc[productId].selections[productSelectionId] = { quantity: 0 };
        }
        acc[productId].quantity += quantity;
        acc[productId].selections[productSelectionId].quantity += quantity;
        return acc;
    }, {});
};
